import { render, staticRenderFns } from "./PlushiePenaltyManagementForm.vue?vue&type=template&id=1a3f1442&scoped=true&"
import script from "./PlushiePenaltyManagementForm.vue?vue&type=script&lang=ts&"
export * from "./PlushiePenaltyManagementForm.vue?vue&type=script&lang=ts&"
import style0 from "./PlushiePenaltyManagementForm.vue?vue&type=style&index=0&id=1a3f1442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3f1442",
  null
  
)

export default component.exports